export default __webpack_public_path__ + "static/media/Fist4.23caf23d.svg";